const initializeChatObj = (
  botTitle,
  botDesc,
  botImg,
  timeStamp,
  conversation
) => {
  return {
    title: botTitle,
    desc: botDesc,
    image: botImg,
    time: timeStamp,
    id: botTitle + timeStamp,
    name: "New Chat",
    conversation: conversation || [],
  };
};

export const getPrevChats = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const prevChats = JSON.parse(localStorage.getItem(token.user.email));

  return prevChats ? prevChats : [];
};

export const setPrevChats = (prevChats) => {
  const token = JSON.parse(localStorage.getItem("token"));
  localStorage.setItem(token.user.email, JSON.stringify(prevChats));
};

export const createNewChat = (
  timeStamp,
  botTitle,
  botDesc,
  botImg,
  conversation
) => {
  const prevChats = getPrevChats();
  const newChat = initializeChatObj(
    botTitle,
    botDesc,
    botImg,
    timeStamp,
    conversation
  );

  const chatObj = [...prevChats, newChat];

  setPrevChats(chatObj);

  return newChat;
};

export const deleteChat = (chatId) => {
  const prevChats = getPrevChats();

  const newPrevChats = prevChats.filter((chat) => chat.id !== chatId);
  const lastChat = JSON.parse(localStorage.getItem("lastChat"));

  if (lastChat.id === chatId) {
    localStorage.setItem(
      "lastChat",
      JSON.stringify(newPrevChats[newPrevChats.length - 1])
    );
  }

  setPrevChats(newPrevChats);
};

export const updateConversation = (chatId, conversation) => {
  const prevChats = getPrevChats();

  const updatedChats = prevChats.map((chat) => {
    if (chat.id === chatId) {
      const newObj = { ...chat, conversation, time: new Date() };
      return newObj;
    }
    return chat;
  });

  setPrevChats(updatedChats);
};

export const getConversation = (chatId) => {
  const prevChats = getPrevChats();

  const chat = prevChats.find((chat) => chat.id === chatId);
  return chat ? chat.conversation : [];
};

export const updateChatName = (chatId, newName) => {
  const prevChats = getPrevChats();

  const updatedChats = prevChats.map((chat) => {
    if (chat.id === chatId) {
      return { ...chat, name: newName };
    }
    return chat;
  });

  setPrevChats(updatedChats);
};
